import Papa, { ParseResult } from "papaparse";
import { GenPoint } from "./types";

export function parseGenCsv(file: File): Promise<GenPoint[]> {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results: ParseResult<any>) => {
        try {
          const rows = (results.data as any[])
            .map((row) => ({
              timestamp: row.timestamp || row.Timestamp,
              value:
                row.value !== undefined
                  ? Number(row.value)
                  : row.generation !== undefined
                  ? Number(row.generation)
                  : null,
            }))
            .filter((r) => r.timestamp);
          resolve(rows);
        } catch (e) {
          reject(e);
        }
      },
      error: reject,
    });
  });
}
